export const fixtureUpdated = 'fixture-updated';
export const driversAdded = 'drivers-added';
export const controlPanelUpdated = 'control-panel-updated';
export const MultiColorDevicesAdded = 'multi-color-devices-added';

const eventAction = [fixtureUpdated, driversAdded, MultiColorDevicesAdded] as const;

export type EventType = typeof eventAction[number];
